import translation from "./translations.json";

const images = {
  AUTH_LOGO: require("./assets/images/authLogo.png"),
  AUTH_BACKGROUND: require("./assets/images/background.png"),
  SIDEBAR_LOGO: require("./assets/images/sidebar.png"),
  BG_1: require("./assets/bg/bg1.png"),
  BG_2: require("./assets/bg/bg2.png"),
  BG_3: require("./assets/bg/bg3.png"),
  BG_4: require("./assets/bg/bg4.png"),
  BG_5: require("./assets/bg/bg5.png"),
  BG_6: require("./assets/bg/bg6.png"),
};

const lightColors = {
  "--color-primary": "#1d4a64",
  "--color-secondary": "#606b89",
  "--color-tertiary": "#5094e2",
  "--color-white": "#ffffff",
  "--background-50": "#1d4a64",
  "--background-100": "#7faac9",
  "--background-200": "#8286ad",
  "--background-300": "#587b90",
  "--background-400": "#709db8",
  "--background-500": "#a6a8c9",
  "--background-600": "#006684",
  "--background-700": "#606b89",
  "--background-800": "#f2f2f2",
  "--background-900": "#ffffff",
  "--background-950": "#1d4a64",
};

const darkColors = {
  "--color-primary": "#7faac9",
  "--color-secondary": "#a6a8c9",
  "--color-tertiary": "#5094e2",
  "--color-white": "#ffffff",
  "--background-50": "#1d4a64",
  "--background-100": "#7faac9",
  "--background-200": "#8286ad",
  "--background-300": "#587b90",
  "--background-400": "#709db8",
  "--background-500": "#a6a8c9",
  "--background-600": "#006684",
  "--background-700": "#606b89",
  "--background-800": "#f2f2f2",
  "--background-900": "#ffffff",
  "--background-950": "#1d4a64",
};

const colors = {
  light: lightColors,
  dark: darkColors,
};

const translations = translation;

const links = {
  support: "https://www.atomservices.io/contact#SUPPORT",
  contact: "https://www.atomservices.io/contact",
  privacyPolicy: "https://www.atomservices.io/privacy-policy",
  terms: "https://www.atomservices.io/terms-and-conditions",
};

const platform = "atomsmartmetering";

export const atomsmartmetering = {
  images,
  colors,
  translations,
  links,
  platform,
  availableReports: [1, 2, 3, 4, 5, 6, 7, 8, 9], // All reports available, adjust as needed
};
